import { country_code, genotype, viruses } from "@prisma/client";

export const passwordPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&.,])[A-Za-z\d@$!%*#?&.,]{12,}$/;
export const passwordRuleMessage =
  "Must contain at least 12 characters with at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character (@$!%*#?&.,).";
export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export interface VirusMetadata {
  genotypes: genotype[];
  serotypes?: number[];
  genotypeColors: Record<string, string>;
  serotypeColors?: Record<number, string>;
}


export const VIRUS_METADATA: Record<viruses, VirusMetadata> = {
  [viruses.DENV]: {
    genotypes: [
      genotype.I,
      genotype.II,
      genotype.III,
      genotype.IV,
      genotype.V,
      genotype.VI,
      genotype.undetermined
    ],
    serotypes: [1, 2, 3, 4],
    // WARNING: also defined in global.css
    genotypeColors: {
      I: "#FF0000",
      II: "#FF8000",
      III: "#FFD900",
      IV: "#00B050",
      V: "#8000FF",
    },
    // WARNING: also defined in global.css
    serotypeColors: {
      1: "#FF0000",
      2: "#FF8000",
      3: "#FFD900",
      4: "#00B050",
    },
  },
  [viruses.CHIKV]: {
    genotypes: [
      genotype.Asian,
      genotype.WA,
      genotype.ECSA_1,
      genotype.ECSA_2,
      genotype.ECSA_IOL
    ],
    genotypeColors: {
      Asian: "#FF0000",
      WA: "#FF8000",
      ECSA_1: "#FFD900",
      ECSA_2: "#00B050",
      ECSA_IOL: "#8000FF",
    },
  },
  [viruses.WNV]: {
    genotypes: [
      genotype.WNV_1,
      genotype.WNV_2,
      genotype.WNV_3,
      genotype.WNV_4,
      genotype.WNV_5,
      genotype.WNV_6,
      genotype.WNV_7,
      genotype.WNV_8,
      genotype.WNV_9],
    genotypeColors: {},
  },
  [viruses.ZIKV]: {
    genotypes: [],
    genotypeColors: {},
  },
};

export const getValidGenotypes = (virus: viruses): genotype[] => {
  return VIRUS_METADATA[virus]?.genotypes || [];
};

export const getValidSerotypes = (virus: viruses): number[] => {
  return VIRUS_METADATA[virus]?.serotypes || [];
};

export const getGenotypeColor = (virus: viruses, genotype: string): string | null => {
  return VIRUS_METADATA[virus]?.genotypeColors[genotype] || null;
};

export const getSerotypeColor = (virus: viruses, serotype: number | null): string | null => {
  if (serotype === null ) {
    return null;
  }

  return VIRUS_METADATA[virus]?.serotypeColors?.[serotype] || null;
};

export const ORGANIZATION_VALIDATION_ERROR =
  "Organization format is invalid. Cannot start with ; or -, end with -, or contain consecutive ;; or --";

export const CODES_FR_AND_OVERSEAS: country_code[] = [
  country_code.GLP, // Guadeloupe
  country_code.MTQ, // Martinique
  country_code.GUY, // Guyane française
  country_code.REU, // La Réunion
  country_code.SPM, // Saint-Pierre-et-Miquelon
  country_code.MYT, // Mayotte
  country_code.BLM, // Saint-Barthélemy
  country_code.MAF, // Saint-Martin
  country_code.WLF, // Wallis-et-Futuna
  country_code.PYF, // Polynésie française
  country_code.NCL, // Nouvelle-Calédonie
  country_code.ATF, // Terres australes et antarctiques françaises
  country_code.FRA, // France métropolitaine
  country_code.FCI, // Clipperton
] as const;
